// extracted by mini-css-extract-plugin
export default {"tasks":"wN-z","task":"xN-z","svg":"yN-z","text":"zN-z"};